export const EXPORT_SALESFORCE_BTN = "si.multi_selector.export_options.salesforce.btn.label";
export const EXPORT_SALESFORCE_ACCOUNT_BTN = "si.multi_selector.export_options.salesforce.account.btn.label";
export const EXPORT_SALESFORCE_LEAD_BTN = "si.multi_selector.export_options.salesforce.lead.btn.label";
export const EXPORT_HUBSPOT_BTN = "si.multi_selector.export_options.hubspot.btn.label";
export const EXPORT_DYNAMICS_BTN = "si.multi_selector.export_options.dynamics.btn.label";
export const EXPORT_DYNAMICS_ACCOUNT_BTN = "si.multi_selector.export_options.dynamics.account.btn.label";
export const EXPORT_DYNAMICS_LEAD_BTN = "si.multi_selector.export_options.dynamics.lead.btn.label";

export const EXPORT_INTEGRATION_TOOLTIP = "si.multi_selector.export_options.salesforce.btn.disabled.tooltip";
export const CONNECT_TO_INTEGRATION_TOOLTIP = "si.multi_selector.export_options.connect_to";
export const ADMIN_ENABLE_EXPORT_INTEGRATION_TOOLTIP =
    "si.multi_selector.export_options.admin_enable_export_integration.tooltip";
export const CRM_IS_NOT_CONNECTED_TOOLTIP = "si.multi_selector.export_options.crm.is.not.connected.tooltip";
